module.exports = __webpack_public_path__ + "img/shield_done.156784e4.svg";